interface ExistingSiteProps {
	id:string,
	formId:string
}

/**
	* Existing site class
	* 
	* @remarks
	* Used mainly in views/DrawTool
	* 
	* @param {number} id - id of the existing site
	* @param {number} formId - id of the form connected to it
*/
export default class ExistingSite implements ExistingSiteProps {
	public id:string;
	public formId:string;
	
	constructor({id, formId}:ExistingSiteProps) {
		this.id = id;
		this.formId = formId;
	}
}